'use client';

import Image from 'next/image';

interface TeamMemberCardProps {
  name: string;
  role: string;
  bio: string;
  image: string;
}

export function TeamMemberCard({ name, role, bio, image }: TeamMemberCardProps) {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.onerror = null;
    target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=6366f1&color=ffffff&size=160&bold=true&format=png`;
  };

  return (
    <div className="bg-background/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-white/20 hover:shadow-xl transition-all duration-300 hover:scale-[1.02] text-center group">
      <div className="flex justify-center mb-6">
        <div className="relative w-24 h-24 rounded-full overflow-hidden ring-4 ring-primary/20 group-hover:ring-primary/40 transition-all duration-300">
          <Image
            src={image}
            alt={name}
            fill
            className="object-cover group-hover:scale-110 transition-transform duration-300"
            onError={handleImageError}
          />
        </div>
      </div>
      <div className="space-y-3">
        <h3 className="text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">{name}</h3>
        <p className="text-primary font-medium text-sm uppercase tracking-wider">{role}</p>
        <p className="text-muted-foreground text-sm leading-relaxed">{bio}</p>
      </div>
    </div>
  );
}
